import { jsx } from "react/jsx-runtime";
import { DelayedRender } from "@fluentui/react/lib/Utilities";
const Announce = (props) => {
  const hiddenElementStyles = {
    clip: "rect(1px, 1px, 1px, 1px)",
    clipPath: "inset(50%)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute"
  };
  const role = props.role || "status";
  const delay = props.delay || 0;
  const ariaLive = props.ariaLive || "assertive";
  return /* @__PURE__ */ jsx("div", { role, "aria-live": ariaLive, children: /* @__PURE__ */ jsx(DelayedRender, { delay, children: /* @__PURE__ */ jsx("span", { style: hiddenElementStyles, "data-automation-id": props.automationId, children: props.message }) }) });
};
export {
  Announce
};
//# sourceMappingURL=Announce.js.map
